var _ellipse, _ellipse2, _mask, _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueTokenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 28,
    viewBox: "0 0 17 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8496_7517)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.5,
    cy: 23.6254,
    rx: 8.3125,
    ry: 4.375,
    fill: "black",
    fillOpacity: 0.35
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.6748,
    cy: 23.1003,
    rx: 6.5625,
    ry: 3.5,
    fill: "black",
    fillOpacity: 0.35
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_8496_7517",
    maskUnits: "userSpaceOnUse",
    x: 1.91992,
    y: -0.474609,
    width: 14,
    height: 27,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 1.91992,
    y: -0.474609,
    width: 14,
    height: 27
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2884 10.0916C10.747 9.39696 10.9795 8.23785 11.5778 7.5916C12.2723 6.84146 12.6994 5.82082 12.6994 4.69622C12.6994 2.39274 10.9073 0.525391 8.69665 0.525391C6.48596 0.525391 4.69385 2.39274 4.69385 4.69622C4.69385 5.80111 5.10616 6.80565 5.77921 7.55191C6.37025 8.20723 6.5886 9.37542 6.04416 10.0699C2.42724 14.6839 2.87089 21.6736 3.01867 23.2044C3.03819 23.4067 3.11594 23.592 3.26164 23.7336C3.80864 24.2653 5.46473 25.5504 8.69458 25.5504C11.9278 25.5504 13.584 24.2626 14.1293 23.732C14.2738 23.5913 14.3512 23.4077 14.3711 23.2069C14.5206 21.6951 14.965 14.8084 11.2884 10.0916Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2884 10.0916C10.747 9.39696 10.9795 8.23785 11.5778 7.5916C12.2723 6.84146 12.6994 5.82082 12.6994 4.69622C12.6994 2.39274 10.9073 0.525391 8.69665 0.525391C6.48596 0.525391 4.69385 2.39274 4.69385 4.69622C4.69385 5.80111 5.10616 6.80565 5.77921 7.55191C6.37025 8.20723 6.5886 9.37542 6.04416 10.0699C2.42724 14.6839 2.87089 21.6736 3.01867 23.2044C3.03819 23.4067 3.11594 23.592 3.26164 23.7336C3.80864 24.2653 5.46473 25.5504 8.69458 25.5504C11.9278 25.5504 13.584 24.2626 14.1293 23.732C14.2738 23.5913 14.3512 23.4077 14.3711 23.2069C14.5206 21.6951 14.965 14.8084 11.2884 10.0916Z",
    fill: "url(#paint0_linear_8496_7517)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1293 23.732L13.8065 23.4003L14.1293 23.732ZM14.3711 23.2069L13.9106 23.1614L14.3711 23.2069ZM3.26164 23.7336L3.5842 23.4018L3.26164 23.7336ZM11.5778 7.5916L11.2382 7.27721L11.5778 7.5916ZM12.2367 4.69622C12.2367 5.70215 11.8549 6.61106 11.2382 7.27721L11.9174 7.90599C12.6896 7.07186 13.1622 5.93949 13.1622 4.69622H12.2367ZM8.69665 0.988168C10.634 0.988168 12.2367 2.6302 12.2367 4.69622H13.1622C13.1622 2.15527 11.1807 0.0626128 8.69665 0.0626128V0.988168ZM5.15663 4.69622C5.15663 2.6302 6.7593 0.988168 8.69665 0.988168V0.0626128C6.21262 0.0626128 4.23107 2.15527 4.23107 4.69622H5.15663ZM6.12286 7.24196C5.52509 6.57917 5.15663 5.68453 5.15663 4.69622H4.23107C4.23107 5.91769 4.68723 7.03213 5.43555 7.86185L6.12286 7.24196ZM3.4793 23.1599C3.4073 22.4141 3.2619 20.3213 3.57867 17.8522C3.89617 15.3775 4.67232 12.5701 6.40837 10.3555L5.67995 9.78444C3.79908 12.1838 2.9886 15.1782 2.66064 17.7345C2.33195 20.2964 2.48225 22.4639 2.55803 23.2489L3.4793 23.1599ZM8.69458 25.0876C5.60247 25.0876 4.05806 23.8624 3.5842 23.4018L2.93908 24.0655C3.55923 24.6683 5.32699 26.0131 8.69458 26.0131V25.0876ZM13.8065 23.4003C13.3344 23.8598 11.7899 25.0876 8.69458 25.0876V26.0131C12.0658 26.0131 13.8337 24.6654 14.452 24.0636L13.8065 23.4003ZM10.9234 10.3761C12.6915 12.6444 13.4816 15.4543 13.8057 17.9116C14.1293 20.3645 13.9833 22.4259 13.9106 23.1614L14.8316 23.2525C14.9084 22.4761 15.0594 20.3382 14.7233 17.7906C14.3879 15.2474 13.5619 12.2556 11.6534 9.80705L10.9234 10.3761ZM14.452 24.0636C14.6863 23.8355 14.8027 23.5446 14.8316 23.2525L13.9106 23.1614C13.8998 23.2707 13.8612 23.347 13.8065 23.4003L14.452 24.0636ZM2.55803 23.2489C2.58639 23.5426 2.70294 23.8359 2.93908 24.0655L3.5842 23.4018C3.52894 23.3481 3.49 23.2707 3.4793 23.1599L2.55803 23.2489ZM5.43555 7.86185C5.66338 8.11446 5.82944 8.48115 5.87864 8.85639C5.92798 9.23276 5.85427 9.56206 5.67995 9.78444L6.40837 10.3555C6.77849 9.88331 6.86782 9.28125 6.79634 8.73607C6.72471 8.18974 6.48607 7.64468 6.12286 7.24196L5.43555 7.86185ZM11.2382 7.27721C10.8707 7.67423 10.6251 8.21437 10.5476 8.75809C10.4701 9.30086 10.5541 9.90232 10.9234 10.3761L11.6534 9.80705C11.4812 9.5862 11.4108 9.26081 11.4638 8.88881C11.5168 8.51777 11.6867 8.15522 11.9174 7.90599L11.2382 7.27721Z",
    fill: "#1E2DB4",
    mask: "url(#path-3-outside-1_8496_7517)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8496_7517",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 13,
    height: 26
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2894 10.2147C10.7479 9.52013 10.9805 8.36102 11.5788 7.71477C12.2733 6.96463 12.7004 5.94399 12.7004 4.81939C12.7004 2.51591 10.9083 0.64856 8.69762 0.64856C6.48694 0.64856 4.69482 2.51591 4.69482 4.81939C4.69482 5.92428 5.10714 6.92882 5.78019 7.67507C6.37122 8.3304 6.58958 9.49859 6.04514 10.1931C2.42822 14.8071 2.87187 21.7968 3.01964 23.3276C3.03917 23.5298 3.11692 23.7152 3.26262 23.8568C3.80962 24.3885 5.4657 25.6735 8.69556 25.6735C11.9288 25.6735 13.585 24.3858 14.1302 23.8551C14.2748 23.7145 14.3522 23.5308 14.3721 23.3301C14.5216 21.8182 14.966 14.9315 11.2894 10.2147Z",
    fill: "url(#paint1_linear_8496_7517)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8496_7517)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_8496_7517)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1458 10.2147C9.60438 9.52013 9.83693 8.36102 10.4352 7.71477C11.1297 6.96463 11.5569 5.94399 11.5569 4.81939C11.5569 2.51591 9.76475 0.64856 7.55407 0.64856C5.34338 0.64856 3.55127 2.51591 3.55127 4.81939C3.55127 5.92428 3.96358 6.92882 4.63663 7.67507C5.22767 8.3304 5.44602 9.49859 4.90158 10.1931C1.28466 14.8071 1.72831 21.7968 1.87609 23.3276C1.89561 23.5298 1.97336 23.7152 2.11907 23.8568C2.66606 24.3885 4.32215 25.6735 7.55201 25.6735C10.7853 25.6735 12.4414 24.3858 12.9867 23.8551C13.1312 23.7145 13.2087 23.5308 13.2285 23.3301C13.378 21.8182 13.8224 14.9315 10.1458 10.2147Z",
    fill: "url(#paint2_linear_8496_7517)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_8496_7517)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.43095 10.2147C7.88953 9.52013 8.12209 8.36102 8.72039 7.71477C9.41486 6.96463 9.84202 5.94399 9.84202 4.81939C9.84202 2.51591 8.04991 0.64856 5.83922 0.64856C3.62854 0.64856 1.83643 2.51591 1.83643 4.81939C1.83643 5.92428 2.24874 6.92882 2.92179 7.67507C3.51283 8.3304 3.73118 9.49859 3.18674 10.1931C-0.430181 14.8071 0.0134681 21.7968 0.161246 23.3276C0.180771 23.5298 0.258517 23.7152 0.404221 23.8568C0.951221 24.3885 2.6073 25.6735 5.83716 25.6735C9.07042 25.6735 10.7266 24.3858 11.2718 23.8551C11.4164 23.7145 11.4938 23.5308 11.5137 23.3301C11.6632 21.8182 12.1076 14.9315 8.43095 10.2147Z",
    fill: "url(#paint3_linear_8496_7517)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.65,
    filter: "url(#filter2_f_8496_7517)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.69483 25.66C5.83931 25.5204 4.34718 24.3564 3.83342 23.857C3.68772 23.7154 3.60997 23.5301 3.59045 23.3278C3.44267 21.797 2.99902 14.8073 6.61594 10.1934C7.16038 9.49883 6.94202 8.33064 6.35099 7.67532C5.67794 6.92906 5.26563 5.92452 5.26563 4.81964C5.26563 2.71834 6.75694 0.979981 8.69689 0.690998C8.51022 0.663191 8.3194 0.648804 8.12536 0.648804C5.91467 0.648804 4.12256 2.51615 4.12256 4.81964C4.12256 5.92452 4.53487 6.92906 5.20792 7.67532C5.79896 8.33064 6.01731 9.49883 5.47287 10.1934C1.85595 14.8073 2.2996 21.797 2.44738 23.3278C2.4669 23.5301 2.54465 23.7154 2.69035 23.857C3.23735 24.3888 4.89344 25.6738 8.1233 25.6738C8.31958 25.6738 8.51006 25.669 8.69483 25.66Z",
    fill: "url(#paint4_linear_8496_7517)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter3_f_8496_7517)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.69483 25.66C5.83931 25.5204 4.34718 24.3564 3.83342 23.857C3.68772 23.7154 3.60997 23.5301 3.59045 23.3278C3.44267 21.797 2.99902 14.8073 6.61594 10.1934C7.16038 9.49883 6.94202 8.33064 6.35099 7.67532C5.67794 6.92906 5.26563 5.92452 5.26563 4.81964C5.26563 2.71834 6.75694 0.979981 8.69689 0.690998C8.51022 0.663191 8.3194 0.648804 8.12536 0.648804C5.91467 0.648804 4.12256 2.51615 4.12256 4.81964C4.12256 5.92452 4.53487 6.92906 5.20792 7.67532C5.79896 8.33064 6.01731 9.49883 5.47287 10.1934C1.85595 14.8073 2.2996 21.797 2.44738 23.3278C2.4669 23.5301 2.54465 23.7154 2.69035 23.857C3.23735 24.3888 4.89344 25.6738 8.1233 25.6738C8.31958 25.6738 8.51006 25.669 8.69483 25.66Z",
    fill: "url(#paint5_linear_8496_7517)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_8496_7517)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.99262,
    cy: 2.49749,
    rx: 1.99262,
    ry: 2.49749,
    transform: "matrix(0.982001 0.188877 -0.174437 0.984668 5.5957 1.00806)",
    fill: "#FFFDF2"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_8496_7517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.62504 3.69088C6.44049 4.27045 6.27081 4.76189 5.97107 4.65826C5.67133 4.55463 5.57795 4.00079 5.76251 3.42122C5.94707 2.84166 6.33967 2.45584 6.63941 2.55947C6.93915 2.6631 6.8096 3.11132 6.62504 3.69088Z",
    fill: "#FFFDF6"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_8496_7517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.40818 25.6733C3.72199 19.4766 6.02836 13.1608 7.26732 10.7775C5.89493 14.8291 6.12367 22.5948 6.40958 25.9712L4.40818 25.6733Z",
    fill: "url(#paint6_linear_8496_7517)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M4.4078 25.6733C3.72161 19.4766 4.69373 13.4587 7.26694 10.7775C5.55147 14.9483 5.24504 22.5948 5.53096 25.9712L4.4078 25.6733Z",
    fill: "url(#paint7_linear_8496_7517)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8496_7517",
    x: 0.0273438,
    y: -1.10144,
    width: 15.0498,
    height: 28.525,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.875,
    result: "effect1_foregroundBlur_8496_7517"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_8496_7517",
    x: -2.25139,
    y: -1.66533,
    width: 16.1776,
    height: 29.6528,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.15694,
    result: "effect1_foregroundBlur_8496_7517"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_8496_7517",
    x: 1.19169,
    y: -0.508141,
    width: 8.66252,
    height: 27.3389,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.578472,
    result: "effect1_foregroundBlur_8496_7517"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_8496_7517",
    x: 1.19169,
    y: -0.508141,
    width: 8.66252,
    height: 27.3389,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.578472,
    result: "effect1_foregroundBlur_8496_7517"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_8496_7517",
    x: 2.79744,
    y: -0.95842,
    width: 8.63852,
    height: 9.6041,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.15694,
    result: "effect1_foregroundBlur_8496_7517"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_8496_7517",
    x: 5.0895,
    y: 1.96413,
    width: 2.30636,
    height: 3.28646,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.289236,
    result: "effect1_foregroundBlur_8496_7517"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_8496_7517",
    x: 1.96931,
    y: 8.46358,
    width: 7.61215,
    height: 19.8215,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.15694,
    result: "effect1_foregroundBlur_8496_7517"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8496_7517",
    x1: 8.69492,
    y1: 0.525391,
    x2: 8.69492,
    y2: 25.5504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0573105,
    stopColor: "#39A8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408737,
    stopColor: "#1341F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8496_7517",
    x1: 8.6959,
    y1: 0.64856,
    x2: 8.6959,
    y2: 25.6736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.63685,
    stopColor: "#1639D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8496_7517",
    x1: 7.55234,
    y1: 0.64856,
    x2: 7.55234,
    y2: 25.6736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.63685,
    stopColor: "#2149FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4565FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8496_7517",
    x1: 5.8375,
    y1: 0.64856,
    x2: 5.8375,
    y2: 25.6736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.63685,
    stopColor: "#2360FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0649F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8496_7517",
    x1: 8.12363,
    y1: 0.648804,
    x2: 8.12363,
    y2: 25.6738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.63685,
    stopColor: "#1C3DCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D2590"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8496_7517",
    x1: 8.12363,
    y1: 0.648804,
    x2: 8.12363,
    y2: 25.6738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#041152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.372132,
    stopColor: "#091D84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8496_7517",
    x1: 5.77526,
    y1: 10.7775,
    x2: 5.77526,
    y2: 25.9712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8496_7517",
    x1: 6.98104,
    y1: 11.6712,
    x2: 5.67235,
    y2: 25.9618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17448,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8496_7517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 28,
    fill: "white",
    transform: "translate(0.1875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueTokenIcon);
export default __webpack_public_path__ + "static/media/blue-token-icon.93c0fe547d2b753dd3c9b26c02d2305b.svg";
export { ForwardRef as ReactComponent };